<template>
  <div class="senior-search">
    <a v-if="pageType === 'databaseBasis'" href="javascript: void(0);" @click.stop="initInput(true)">高级搜索</a>
    <template v-if="pageType === 'databaseBasis'">
      <w-dialog :show="showDialog"
                show-close
                :box-style="{width:'500px'}"
                title="高级搜索"
                :wallStyle="{zIndex: 1009}"
                footer-style="padding-bottom: 24px;border-top: 0;"
                @close="showDialog = false">
        <div class="padding-0-20 senior-search--body">
          <table class="form-table" width="100%" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
              <th class="font-right" width="60">{{page === 'combination' || page === 'inventory' ? '名称或项目特征' : '名称'}}：</th>
              <td>
                <w-input size="small" class="ui-w300" v-model="query.descOrSpec" name="advanceDescOrSpec" id="advanceDescOrSpec"></w-input>
              </td>
            </tr>
            <tr v-if="page !== 'material'">
              <!-- 非人材机 -->
              <th class="font-right">编码：</th>
              <td>
                <w-input size="small" class="ui-w300" v-model="query.code" name="searchCode" id="searchCode"></w-input>
              </td>
            </tr>
            <tr v-if="page === 'material'">
              <!-- 人材机 -->
              <th class="font-right">规格型号：</th>
              <td>
                <w-input size="small" class="ui-w300" v-model="query.spec" name="searchSpec" id="searchSpec"></w-input>
              </td>
            </tr>
            <tr>
              <th class="font-right">上传人：</th>
              <td>
                <w-select size="small" name="authorId" id="authorId" v-model="query.authorId" class="ui-w300">
                  <w-option value="" label="全部"></w-option>
                  <w-option v-for="(item, idx) in authors"
                          :key="page + '_author_' + idx"
                          :label="item.name"
                          :value="item.glduserid">
                  </w-option>
                </w-select>
              </td>
            </tr>
            <tr>
              <th class="font-right">审核状态：</th>
              <td>
                <w-select size="small" name="bqInspected" id="bqInspected" v-model="query.inspected" class="ui-w300">
                  <w-option value="" label="全部"></w-option>
                  <w-option :value="0" label="待审核"></w-option>
                  <w-option :value="1" label="审核已通过"></w-option>
                  <w-option :value="2" label="审核未通过"></w-option>
                </w-select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <template slot="footer">
          <w-button type="primary" size="small" @click="submitHandle">确认</w-button>
          <w-button type="minor" @click="cancel">取消</w-button>
        </template>
      </w-dialog>
    </template>
  </div>
</template>
<script>
import api from '@/assets/service'
import {mapState} from 'vuex'
import { getCookie } from '@/assets/utils/CommonUtil'
export default {
  name: 'DialogSeniorSearch',
  props: {
    page: {
      type: String,
      default: 'combination' // combination: 组价、inventory: 清单、material: 人材机 、quota: 定额
    }
  },
  data () {
    return {
      showDialog: false,
      authors: [],
      query: {
        descOrSpec: '', // 名称
        code: '', // 编码
        spec: '', // 规格型号
        authorId: '', // 编制人
        inspected: '' // 审核状态
      },
      user: {}
    }
  },
  computed: {
    ...mapState({
      userInfoReady: state => state.user.userInfoReady
    })
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo){
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    // this.initInput()
  },
  methods: {
    // 1. 初始化输入框
    initInput (showDialog) {
      // console.log(this.pageType)
      if (this.userInfoReady) {
        if (this.pageType !== 'databaseBasis') return
        // 获取编制人列表
        api[this.page].getAuthors().then((data) => {
          if (+data.code === 200) {
            this.authors = data.data || []
            // 当某个用户的数据被全部删除后 上传人列表中 不存在此用户时下拉框 不返现用户ID
            let userExist = false
            if (this.query.authorId) {
              this.authors.forEach((user) => {
                if (user.glduserid === this.query.authorId) {
                  userExist = true
                }
              })
            }
            if (!userExist) {
              this.query.authorId = ''
            }
          }
        }).finally(() => {
          if (showDialog) {
            this.showDialog = true
          }
        })
      }
    },
    // 2. 开始搜索
    submitHandle () {
      this.$emit('onSearch', this.query)
      this.showDialog = false
    },
    cancel () {
      this.showDialog = false
    }
  },
  watch: {
    'userInfoReady': function () {
      this.initInput()
    }
  }
}
</script>
<style lang="less" type="text/less">
  .senior-search{
    font-size: 12px;
    &>a:link{
      margin-left: 10px;
      color: #2079FA;
    }
  }
  .senior-search--body {
    .form-table th,.form-table td {
      padding: 10px 0;
      font-size: 12px;
      position: relative
    }
    .form-table th {
      color: #333;
      font-weight: normal;
      padding-left: 10px;
      padding-right: 10px;
      line-height: 16px;
    }

    select {
      padding: 3px;
      border: 1px solid #ccc;
      color: #666
    }

    select:hover,select:focus {
      border-color: #A8C4E3;
      outline: 0
    }

    .ui-select {
      padding: 5px 3px;
      border: 1px solid #ccc;
      color: #666
    }

    .ui-select:hover,.ui-select:focus {
      border-color: #A8C4E3;
      outline: 0
    }

    .ui-input {
      border: 1px solid #ccc;
      height: 28px;
      line-height: 28px;
      background-color: #fff;
      font-size: 12px;
      color: #666;
      padding: 0 5px;
      width: 225px;
      display: inline-block;
      vertical-align: middle
    }

    .ui-input:hover,.ui-input:focus {
      border-color: #A8C4E3;
      outline: 0
    }

    .ui-input::-webkit-input-placeholder {
      color: #c2c2c2
    }

    .ui-input:-moz-placeholder {
      color: #c2c2c2
    }
    .ui-w300 {
      width: 300px !important;
    }
    .ui-w310 {
      width: 310px !important;
    }
  }
</style>
